// assets/abevo.js

// Mobile menu toggle
document.addEventListener('DOMContentLoaded', function () {
  const burger = document.querySelector('.abevo-header__burger');
  const nav = document.querySelector('.abevo-header__nav');

  if (burger && nav) {
    burger.addEventListener('click', function () {
      nav.classList.toggle('abevo-nav--open');
    });
  }
});